import { reactive } from "vue";

export type ToastKind = "info" | "success" | "error";

export interface Toast {
  id: number;
  kind: ToastKind;
  message: string;
  /** Stays until dismissed; default true for errors, false otherwise. */
  sticky: boolean;
}

const state = reactive<{ toasts: Toast[] }>({ toasts: [] });
let nextId = 1;

export function pushToast(message: string, kind: ToastKind = "info", sticky?: boolean): number {
  const id = nextId++;
  const t: Toast = {
    id,
    kind,
    message,
    sticky: sticky ?? kind === "error",
  };
  state.toasts.push(t);
  // Cap visible toasts (newest 4) per ui-ux-design.md §5.
  if (state.toasts.length > 4) state.toasts.shift();
  if (!t.sticky) {
    setTimeout(() => dismissToast(id), 5000);
  }
  return id;
}

export function dismissToast(id: number): void {
  const idx = state.toasts.findIndex((t) => t.id === id);
  if (idx >= 0) state.toasts.splice(idx, 1);
}

export function useToasts() {
  return { toasts: state.toasts, push: pushToast, dismiss: dismissToast };
}
